export default "__VITE_PUBLIC_ASSET__7d077d76__"